import { createSlice } from '@reduxjs/toolkit';

export const bgTasksSlice = createSlice({
  name: 'bg-tasks',
  initialState: {
    tasks: [],
    selected: undefined,
  },
  reducers: {
    select: (state, action) => {
      const { payload } = action;
      state.selected = state.tasks.find((t) => t.id === payload);
    },

    createBgTask: () => {},
    createBgTaskSuccess: () => {},
    createBgTaskFail: (state, action) => {
      state.isError = true;
      state.error = action.payload;
    },
    newBgTasks: (state, action) => {
      state.tasks.push(...action.payload);
    },
    modifyBgTasks: (state, action) => {
      state.tasks = state.tasks.map(
        (task) => action.payload.find((data) => data.id === task.id) ?? task
      );
    },
  },
});

export const bgTasksActions = bgTasksSlice.actions;

export default bgTasksSlice.reducer;
